import React from 'react'
import page from 'page'

//const navInfo = () => console.log(window.location.pathname)
export default ({ to, className, onClick, children }) => {
  function handleClick (e) {
    e.preventDefault()
    onClick && onClick(e)
    to && page(to)
    window.PopMechanic.update()
  }

  return (
    <a href={to} className={className} onClick={(e) => handleClick(e)}>{children}</a>
  )
}



// WEBPACK FOOTER //
// ./src/components/Link.jsx